export const DestinationPopularity = {
    RARELY_EXPLORED: 1,
    OCCASIONALLY_EXPLORED: 2,
    REGULARLY_EXPLORED: 3,
    FREQUENTLY_EXPLORED: 4,
    HIGHLY_EXPLORED: 5,
    INTENSIVELY_EXPLORED: 6,
} as const;
